import React from 'react';
import styled from 'styled-components';
import Link from 'next/link';
import { SCREEN_SIZE } from '../../lib/mediaQuery';

const StyledHeaderFromTablet = `
  height: 4rem;
  margin-bottom: 1.5rem;
`;

const StyledHeader = styled.div`
  background-color: white;
  width: 100%;
  height: 3.625rem;
  display: flex;
  visibility: visible;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;

  ${SCREEN_SIZE.From.Tablet} {
    ${StyledHeaderFromTablet}
  }
  @media print {
    ${StyledHeaderFromTablet}
  }
`;
const LogoWrapperFromTablet = `
  width: 8.6875rem;
  height: 1.875rem;
  margin: 1.5625rem;
`;
const LogoWrapper = styled.div`
  margin: 0.8rem;
  width: 5.5625rem;
  position: relative;
  animation-name: fadeInLater;
  animation-duration: 1s;

  ${SCREEN_SIZE.From.Tablet} {
    ${LogoWrapperFromTablet}
  }

  @media print {
    ${LogoWrapperFromTablet}
  }
`;
const StyledWrapper = styled.div`
  justify-content: center;
  width: 100%;
  background-color: #fff;
  z-index: 9998;
  position: fixed;
  top: 0;
  border-bottom: 0.0625rem solid #eaeaea;
  padding: 0 1.25rem;

  ${SCREEN_SIZE.From.Tablet} {
    padding: 0 2.5rem;
  }
  ${SCREEN_SIZE.From.Desktop} {
    padding: 0 3.75rem;
  }
`;

const ReceiverHeader = () => {
  return (
    <Link href="/">
      <StyledHeader data-testid="fp-logo-header">
        <StyledWrapper>
          <LogoWrapper>
            <img
              alt="Fairprice"
              src="https://media.nedigital.sg/fairprice/files/a6566ce4-1904-40cb-800f-9d562b65b8c7/FP_gifting_logo.svg"
              width="139"
              height="30"
              sizes="8.6875rem"
            />
          </LogoWrapper>
        </StyledWrapper>
      </StyledHeader>
    </Link>
  );
};

export default ReceiverHeader;
